import React, { FunctionComponent } from 'react';
import { Query } from 'react-apollo';
import { ApolloError, DocumentNode } from 'apollo-boost';
import { path } from 'ramda';

import ErrorBoundary from '../ErrorBoundary';
import { getGraphQLError, defaultErrorMessage } from 'helpers/getGraphQLError';

type Props = {
  query: DocumentNode;
  variables: any;
  render: Function;
  pollInterval: number;
  pathCondition: string[];
  PlaceholderLoading: React.ElementType;
};

export type ResponseParams = {
  data?: Record<string, unknown>;
  loading?: boolean;
  error?: ApolloError;
  stopPolling: Function;
};

const PollingQuery: FunctionComponent<Props> = ({
  query,
  variables,
  render,
  pollInterval,
  pathCondition,
  PlaceholderLoading,
}) => (
  <ErrorBoundary>
    <Query
      query={query}
      variables={variables}
      pollInterval={pollInterval}
      notifyOnNetworkStatusChange={pollInterval > 0}
    >
      {({ loading, error, data, stopPolling }: ResponseParams) => {
        const pollingCompleted = path(pathCondition, data);
        const pollingLoading = pollInterval > 0 && !path(pathCondition, data);
        const isLoading = loading || pollingLoading;

        if (isLoading) {
          return <PlaceholderLoading />;
        }

        if (error) {
          getGraphQLError(defaultErrorMessage, true, error);
        }

        if (pollingCompleted) {
          stopPolling();
        }

        return render(data);
      }}
    </Query>
  </ErrorBoundary>
);

export default PollingQuery;
